import React, {useState} from 'react'
import { BulkUploadStdPricingView } from './BulkUploadStdPricingView'
import { parseFormData } from '../../../utils/formsUtils'
import axios from 'axios'

//used for changing shipping prices
export const BulkUploadStdPricing = () => {
    const [password, setPassword] = useState('')
    const onSubmit = (e) => {
        e.preventDefault()
        const formData = parseFormData(e)
        console.log({formData})
        axios  
            .post(process.env.REACT_APP_HOST + 'api/pricing/bulkUpdate', {formData})
            .then((res) => {
                console.log(res.data)
            })
    }

    return <BulkUploadStdPricingView 
        password={password}
        setPassword={setPassword}
        onSubmit={onSubmit}
        />
}

